import { Component, Input, TemplateRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class DialogComponent {

    @Input() closeButton = true;

    @Input() contentTemplate: TemplateRef<any> | null = null;

    @ViewChild('dialog') dialogElement?: TemplateRef<any>;

    public dialogReference?: MatDialogRef<any>;

    constructor(public dialog: MatDialog) {
    }

    open() {
        if (!this.dialogElement) {
            console.error('The dialog element is not defined.');

            return;
        }

        this.dialogReference = this.dialog.open(this.dialogElement, {
            width: '734px',
            panelClass: ['close-dialog', 'padding-0'],
            autoFocus: false,
        });
    }

    close(): void {
        this.dialogReference?.close();
    }
}
